import type {OrderDetailsData} from 'modules/Orders/types';
import type {
  OrderReportTrip,
  OrderReportTripTracking,
  OrderStatusVendor
} from 'modules/Orders/OrderStatus/types';

import {Button, CollapsibleBottomSheet} from '@ds/components';
import {useEffect, useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import {routes} from 'routes/routes';
import {useAppDispatch, useAppSelector} from 'store';
import {
  getOrder,
  getOrdersReportTrip,
  getOrdersReportTripTracking
} from 'store/slices/order/thunk';
import {getSelectedVendorFromStorage} from 'utils/Helper';

import DeliveryStatus from './components/DeliveryStatus/DeliveryStatus';
import OrderStatusDetails from './components/OrderStatusDetails/OrderStatusDetails';
import OrderStatusMap from './components/OrderStatusMap/OrderStatusMap';

const OrderStatus: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const {orderId} = useParams();
  const vendor = getSelectedVendorFromStorage() as OrderStatusVendor | null;
  const vendorId = vendor?.id ?? '0';
  const [isBottomSheetOpen, setIsBottomSheetOpen] = useState(true);
  const {order: orderState, ordersReportTrip, ordersReportTripTracking} = useAppSelector(
    (state) => state.order
  );
  const order = orderState as OrderDetailsData;
  const trip = ordersReportTrip as OrderReportTrip;
  const tracking = ordersReportTripTracking as OrderReportTripTracking;

  useEffect(() => {
    if (!orderId) {
      return;
    }

    void dispatch(getOrder({orderId, vendor_id: vendorId}));
    void dispatch(getOrdersReportTrip({order_id: orderId, vendor_id: vendorId}));
    void dispatch(getOrdersReportTripTracking({order_id: orderId, vendor_id: vendorId}));
  }, [dispatch, orderId, vendorId]);

  const handleInvoiceNavigation = () => {
    navigate(`/orders/${orderId}`);
  };

  const handleSupportNavigation = () => {
    const query = new URLSearchParams({
      type: 'order',
      from: `/orders/${orderId}/status`
    });

    if (order.current?.order_code) {
      query.set('order_code', order.current.order_code);
    }

    navigate(`${routes.TICKETS}?${query.toString()}`);
  };

  return (
    <div className="flex h-full w-full flex-col overflow-y-auto">
      <OrderStatusMap vendorAttributes={vendor?.attributes} tracking={tracking} />

      <div
        className="fixed left-1/2 z-10001 w-full max-w-mobile -translate-x-1/2 p-2.5 transition-[bottom] duration-300 ease-in-out"
        style={{bottom: isBottomSheetOpen ? 400 : 40}}
      >
        <DeliveryStatus deliveryType={order.current?.expedition_type} trip={trip} />
      </div>

      <CollapsibleBottomSheet
        height={400}
        showDragHandle
        show={isBottomSheetOpen}
        onOpenChange={setIsBottomSheetOpen}
        canceledOnTouchOutside={false}
      >
        <div className="flex h-full min-h-0 flex-col justify-between">
          <OrderStatusDetails
            order={order.current}
            onInvoiceClick={handleInvoiceNavigation}
          />
          <div className="shrink-0 px-2">
            <Button fullWidth onClick={handleSupportNavigation} variant="outline">
              درخواست‌های پشتیبانی
            </Button>
          </div>
        </div>
      </CollapsibleBottomSheet>
    </div>
  );
};

export default OrderStatus;
